module.exports = __webpack_public_path__ + "media/assets/icons/ic-code-29b8882c61bbb62334293fae0c2c0825.svg";